import { Maybe } from "graphql/jsutils/Maybe";

import { Slice } from "../store.decl";

type SearchContentMatches = Map<
  number,
  {
    content: string;
    terms: (string | null)[];
  }
>;

export type SearchContentMatchesSliceState = {
  searchContentMatches: Maybe<SearchContentMatches>;
  setSearchContentMatches: (
    searchContentMatches: Maybe<SearchContentMatches>
  ) => void;
};

export const createSearchContentMatchesSlice: Slice<
  SearchContentMatchesSliceState
> = (set) => ({
  searchContentMatches: null,
  setSearchContentMatches: (searchContentMatches) => {
    set(() => ({
      searchContentMatches,
    }));
  },
});
